module.exports = __webpack_public_path__ + "static/media/email-@.2931eb63.svg";